import { Box, Typography, Button } from '@mui/material'
import WestIcon from '@mui/icons-material/West'
import { useLocation } from 'react-router-dom'

interface ErrorMessageProps {
  message?: string
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
  const location = useLocation()
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '50%',
        margin: '0 auto',
        height: '80vh',
        color: '#1C3045',
      }}
    >
      <Typography
        variant="body1"
        sx={{ mb: 1, fontSize: '20px', textAlign: 'center' }}
      >
        {message || "Oops! Something went wrong...  We're on it!"}
      </Typography>
      {location.pathname !== '/' && (
        <Box sx={{ textAlign: 'center', width: '100%' }}>
          <Button
            variant="outlined"
            disableRipple
            onClick={() => (window.location.href = '/')}
            sx={{
              mt: 2,
              borderColor: '#1C3045',
              color: '#1C3045',
              width: '50%',
              minWidth: '200px',
              maxWidth: '250px',
              '&:focus': {
                backgroundColor: '#e8e8e8',
              },
            }}
          >
            <WestIcon sx={{ mr: '10%', fontSize: '22px' }} /> Go back to home
            page
          </Button>
        </Box>
      )}
    </Box>
  )
}
